import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';
import {PostcodeAutofill} from './types';
import {cleanPostcode} from './utils';

export type PostcodeAutoFillSuccessResponse =
    Api.Response.Success<PostcodeAutofill>;

export type PostcodeAutoFillErrorResponse = Api.Response.Failure<'value'>;

export const useGetPostcodeAutoFill = (): UseMutationResult<
    PostcodeAutoFillSuccessResponse,
    PostcodeAutoFillErrorResponse,
    string
> => {
    const locale = useLocale();

    return useMutation((postcode) =>
        request({
            locale,
            method: 'GET',
            uri: `/api/address/zipcode/${cleanPostcode(postcode)}/`,
        }),
    );
};
